function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.891
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.135 5.637a3.366 3.366 0 106.732 0 3.366 3.366 0 00-6.732 0zM22.505 50.202c.623 2.749 3.058 4.803 5.996 4.803s5.373-2.054 5.996-4.803c-4.024.2-7.978.202-11.992 0z",
  strokeWidth: 0.9997020000000001
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.501 9.003c-3.63 0-8.168.617-10.659 3.787-2.822 3.592-3.366 10.087-3.366 15.848v1.297c0 4.12-.903 7.955-2.454 11.115 11.312 1.29 22.338 1.476 32.959 0-1.551-3.16-2.455-6.994-2.455-11.115v-1.297c0-5.848-.469-12.251-3.366-15.848-2.475-3.074-7.09-3.787-10.659-3.787z",
  strokeWidth: 0.9997020000000001
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.986 41.05c1.591 3.243 3.86 5.784 6.516 7.223-16.372 2.812-29.76 2.764-46.002 0 2.658-1.439 4.926-3.98 6.517-7.223 11.312 1.29 22.348 1.475 32.969 0z",
  strokeWidth: 0.9997020000000001
}));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bell.78a59611.svg";
export { ForwardRef as ReactComponent };